import React from 'react';

const Shadow = (props) =>{
    const {className,children} = props;
    return <p className={"shadow-text " + className}>{children}</p>;
}

export default Shadow;